import '@fontsource/inter';
import React from 'react';
import CurrentTime from '../components/CurrentTime';
import DynamicIsland from '../components/DynamicIsland';
import Back from '../components/Back';
import './TechHelp.css';

function TechHelp() {
    return (
        <section className="tech-container">
            <CurrentTime />
            <DynamicIsland />
            <Back />
            <div className="tech-help">
                <h1>Tech Help</h1>
                <h3>
                    TechHelp is the Office of Technology Services’ (OTS) online system for requesting tech support, submitting IT project requests, asking questions, or providing feedback on TU’s technology-related topics.
                </h3>
            </div>
            <div className="textfield">
                <label htmlFor="issue"></label>
                <textarea
                    id="issue"
                    name="issue"
                    placeholder="Describe your issue here..."
                ></textarea>
            </div>
            <button type="submit" className="tech-submit">
                Send
            </button>
            <div className="tiger-logo-bottom">
                <img className="tech-tiger-logo" src="./img/towson-tiger.png"/>
            </div>
            <div className="contact">
                <h4>Technology Support Desk</h4>
                <p>For students, faculty, and staff</p>
                <p>Phone: 410-704-5151</p>
                <p>Email: <a href="mailto:techsupport@towson.edu">techsupport@towson.edu</a></p>
                <p>SMS Text: 410-324-7271</p>
                <p>
                    Locations: Cook Library, Main floor-Academic Commons Tech
                    Services Desk & TUNE Tech Services Desk Rm. 206
                </p>

                <h4>Blackboard</h4>
                <p>
                    Phone (Students): 410-704-5151 (options 1, 5)<br />
                    Phone (Faculty/Staff): 410-704-5151 (options 2, 4)<br />
                </p>

                <h4>Classroom Technology</h4>
                <p>
                    Phone: 410-704-TECH (8324)<br />
                    Telecommunications (Phones):<br />
                    Phone: 410-704-5151 (options 2, 3)<br />
                </p>
            </div>
            <div className="hours-operation">
                <h1>Hours of Operation</h1>
                <h3>Fall and Spring
                    <br/> <span>Fall hours start on Sunday, Aug. 25.</span>
                </h3>
                <table>
                <tr>
                <th>Day</th>
                <th>Hours</th>
              </tr>
              <tr>
                <td>Monday-Thursday</td>
                <td>8 a.m. - 10 p.m.</td>
              </tr>
              <tr>
                <td>Friday</td>
                <td>8 a.m. - 5 p.m.</td>
              </tr>
              <tr>
                <td>Saturday</td>
                <td>Closed</td>
              </tr>
              <tr>
                <td>Sunday</td>
                <td>12 p.m. - 6 p.m.</td>
              </tr>
                </table>
                <h3>Winter/Minimester and Summer</h3>
                <table>
                <tr>
                <th>Day</th>
                <th>Hours</th>
              </tr>
              <tr>
                <td>Monday-Thursday</td>
                <td>8 a.m. - 5 p.m.</td>
              </tr>
              <tr>
                <td>Friday</td>
                <td>8 a.m. - 4 p.m.</td>
              </tr>
              <tr>
                <td>Saturday & Sunday</td>
                <td>Closed</td>
              </tr>
                </table>
            </div>
        </section>
    );
}

export default TechHelp;
